export const Heading1 = ({ title }) => {
  return <h3 className="fz-20">{title}</h3>;
};
